import type { ChartSeries } from './types';

/**
 * `ChartSeries[]` → `key → series` Map. custom `CartesianTooltip` 의 `seriesByKey` 구성 공용(소비처 반복 제거).
 * `CartesianChart` 는 기본 툴팁용 map 을 내부 생성하지만, custom 툴팁을 넘길 땐 소비처가 이 헬퍼로 구성한다.
 */
export function toSeriesMap(series: ChartSeries[]): Map<string, ChartSeries> {
  return new Map(series.map((s) => [s.key, s]));
}
